import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { BFIslandButton, BFIslandColors } from '@buzzfeed/react-components';
import { useTrackingContext } from '../../hooks';
import Card from './Card';
import styles from './index.module.scss';

const GENERATORS_PACKAGE_ID = 108827;
const MAX_VISIBLE_GENERATORS = 5;

const TryMoreGenerators = () => {
  const router = useRouter();
  const [generatorItems, setGeneratorItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { trackInternalLink } = useTrackingContext();

  useEffect(() => {
    const fetchGeneratorsPackage = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `/api/island-api/v1/content-objects/package/${GENERATORS_PACKAGE_ID}`
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch generators package: ${response.status}`);
        }

        const data = await response.json();
        const items = data?.package_feed?.items || [];
        setGeneratorItems(items);
      } catch (error) {
        console.error('Failed to fetch generators carousel package', error);
        setGeneratorItems([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchGeneratorsPackage();
  }, []);

  const trackSeeAllClick = (itemType) => {
    trackInternalLink({
      unit_type: 'section',
      unit_name: 'generators_carousel',
      item_type: itemType,
      item_name: 'see_all',
      target_content_type: 'page',
      target_content_id: 'discover',
    });
  };

  const handleSeeAllLinkClick = () => {
    trackSeeAllClick('link');
  };

  const handleSeeAllButtonClick = () => {
    trackSeeAllClick('button');

    router.push('/discover');
  };

  const handleCardClick = (item, index) => {
    trackInternalLink({
      unit_type: 'section',
      unit_name: 'generators_carousel',
      item_type: 'card',
      item_name: item?.id,
      position_in_unit: index,
      target_content_type: 'widget',
      target_content_id: item?.id,
    });
  };

  const showSkeleton = isLoading;
  const visibleItems = generatorItems.slice(0, MAX_VISIBLE_GENERATORS);

  if (!isLoading && !visibleItems.length) {
    return null;
  }

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Try more generators</h2>
        <Link href="/discover">
            <a className={`${styles.seeAll} ${styles.seeAllDesktop}`} onClick={handleSeeAllLinkClick}>
            See all
          </a>
        </Link>
      </div>
      <div className={styles.railViewport}>
        <div className={styles.rail}>
          {showSkeleton ? (
            <>
              <div className={styles.skeletonItem} />
              <div className={styles.skeletonItem} />
              <div className={styles.skeletonItem} />
              <div className={styles.skeletonItem} />
              <div className={styles.skeletonItem} />
            </>
          ) : (
            visibleItems.map((item, index) => (
              <Card
                key={item?.id || index}
                item={item}
                index={index}
                onClick={() => handleCardClick(item, index)}
              />
            ))
          )}
        </div>
      </div>
      <div className={styles.mobileSeeAllButton}>
        <BFIslandButton
          text="See all"
          size="medium"
          fullWidth
          bgColor={BFIslandColors.CYAN}
          onClick={handleSeeAllButtonClick}
        />
      </div>
    </section>
  );
};

export default TryMoreGenerators;
